import { Box, Button, TextField, Tooltip, Typography, useTheme } from '@mui/material'
import { useState } from 'react'
import { IChangelog, IComment } from '../../definitions/Workflow'
import Formatter from '../../helpers/Formatter'
import Helper from '../../helpers/Helper'
import UsersManager from '../../managers/UsersManager'
import Tile from '../layout/Tile'

interface P {
    comments?: IComment[]
    onChange?: (newComments: IComment[], newChangelogs: IChangelog[]) => void
}

export default function Comments({ comments, onChange }: P) {
    const theme = useTheme()
    const [textNewComment, setTextNewComment] = useState('')
    const imageSize = 30

    const onSendComment = async () => {
        const selectedUser = await UsersManager.getCurrentUser()
        const newComment: IComment = {
            uuid: Helper.generateUUID('comment_'),
            text: textNewComment,
            createdAt: new Date().toISOString(),
            user: selectedUser,
            replies: []
        }

        const newChangelog: IChangelog = {
            uuid: Helper.generateUUID('log_'),
            activity: 'comment',
            activityType: 'new',
            before: null,
            after: { uuid: newComment.uuid, text: newComment.text },
            createdAt: newComment.createdAt,
            user: selectedUser
        }
        const newComments = [newComment, ...(comments ?? [])]
        onChange(newComments, [newChangelog])
        setTextNewComment('')
    }

    const renderCommentCard = (comment: IComment) => {
        const createdAt = new Date(comment.createdAt)
        return (
            <Tile.Column key={'commentCard' + comment.uuid} style={{ marginBottom: theme.spacing(5) }}>
                <Tile.Row spacing={1} alignItems='center'>
                    <img src={comment.user.image} style={{ height: imageSize, width: imageSize, borderRadius: '100%' }} />
                    <Typography marginLeft={1} variant='subtitle2' fontWeight={700}>{comment.user.name}</Typography>
                    <Typography fontSize={15} color={theme.palette.text.disabled}>·</Typography>
                    <Tooltip title={Formatter.date(createdAt)}>
                        <Typography fontSize={12} color={theme.palette.text.disabled}>{Formatter.timeAgo(createdAt)}</Typography>
                    </Tooltip>
                </Tile.Row>
                <Tile.Column style={{ paddingLeft: imageSize + parseInt(theme.spacing(2)) }}>
                    <Typography variant='body2' marginTop={1}>{comment.text}</Typography>
                    <Typography marginTop={1} fontWeight={600} variant='body2' sx={{ cursor: 'pointer' }}>Reply</Typography>
                </Tile.Column>
            </Tile.Column>
        )
    }

    return (
        <Box paddingRight={2} paddingTop={2}>
            <TextField
                fullWidth
                autoComplete='off'
                placeholder='Add your comment...'
                multiline
                maxRows={3}
                minRows={3}
                variant='outlined'
                value={textNewComment}
                onChange={e => setTextNewComment(e.target.value)}
            />
            <Box marginTop={1} display='flex' justifyContent='flex-end'>
                <Button variant='contained' onClick={onSendComment} disabled={textNewComment?.length < 3}>Submit Comment</Button>
            </Box>
            <Box marginTop={2}>
                {comments?.map(x => {
                    return renderCommentCard(x)
                })}
            </Box>
        </Box>
    )
}
